(() => {
  if (window.__dripstockCartRemoveSoundBound) return;
  window.__dripstockCartRemoveSoundBound = true;

  let audioContext = null;
  let lastPlayedAt = 0;

  function playRemovePop() {
    if (window.DripstockSound && !window.DripstockSound.enabled()) return;
    const nowMs = Date.now();
    if (nowMs - lastPlayedAt < 180) return;
    lastPlayedAt = nowMs;

    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return;

      if (!audioContext) audioContext = new AudioCtx();
      if (audioContext.state === 'suspended') audioContext.resume();

      const now = audioContext.currentTime;
      const master = audioContext.createGain();
      const tone = audioContext.createOscillator();
      const body = audioContext.createOscillator();
      const toneGain = audioContext.createGain();
      const bodyGain = audioContext.createGain();

      master.gain.setValueAtTime(0.0001, now);
      master.gain.exponentialRampToValueAtTime(0.055, now + 0.004);
      master.gain.exponentialRampToValueAtTime(0.0001, now + 0.16);
      master.connect(audioContext.destination);

      tone.type = 'sine';
      tone.frequency.setValueAtTime(330, now);
      tone.frequency.exponentialRampToValueAtTime(180, now + 0.09);
      toneGain.gain.setValueAtTime(0.0001, now);
      toneGain.gain.exponentialRampToValueAtTime(0.11, now + 0.004);
      toneGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.11);
      tone.connect(toneGain);
      toneGain.connect(master);

      body.type = 'sine';
      body.frequency.setValueAtTime(145, now);
      body.frequency.exponentialRampToValueAtTime(82, now + 0.12);
      bodyGain.gain.setValueAtTime(0.0001, now);
      bodyGain.gain.exponentialRampToValueAtTime(0.075, now + 0.006);
      bodyGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.14);
      body.connect(bodyGain);
      bodyGain.connect(master);

      tone.start(now);
      body.start(now);
      tone.stop(now + 0.13);
      body.stop(now + 0.16);
    } catch (error) {}
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const removeButton = target.closest('.cart-items__remove');
    if (!removeButton || removeButton.disabled || removeButton.getAttribute('aria-disabled') === 'true') return;

    playRemovePop();
  }, true);
})();